export const URL_TO_RETURN_AFTER_LOGOUT = 'urlToReturnTo';
export const SESSION_ID = 'sessionId';
export const REQUEST_ID = 'requestId';
